import s from './Search.module.css';
import { fetchAllBreeds } from 'services/API/API';
import { NavigationHeader } from 'components/NavigationHeader/NavigationHeader';
import { CatsCollection } from 'components/CatsCollection/CatsCollection';
import { BackButton } from 'components/BackButton/BackButton';
import { SearchLabel } from 'components/MenuLabels/SearchLabel/SearchLabel';
import { NotFound } from 'components/NotFound/NotFound';
import { LabelStyleBreeds } from 'components/CatsCollection/labelStyleBreeds';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

const Search = () => {
  const location = useLocation();

  const [breed, setBreed] = useState(
    useSelector(state => state.queryReducer.query)
  );
  const [images, setImages] = useState([]);
  const [status, setStatus] = useState(null);

  const queryformredux = useSelector(state => state.queryReducer.query);

  useEffect(() => {
    setBreed(queryformredux);
  }, [queryformredux]);

  useEffect(() => {
    setStatus('pending');
    breed.length
      ? fetchAllBreeds(20, breed)
          .then(images => setImages(images))
          .finally(setStatus('resolved'))
      : setImages([]);
  }, [breed]);

  return (
    <div className={s.container}>
      <div className={s.nav}>
        <NavigationHeader />
      </div>
      <div className={s.result}>
        <div className={s.back__label}>
          <BackButton path={location.state ? location.state.path : '/'} />
          <SearchLabel />
        </div>
        <p className={s.search__label__result}>Search result for: </p>
        <p className={s.query}>{breed.query}</p>

        {status === 'resolved' && images.length ? (
          <CatsCollection
            images={images}
            destination={'breed'}
            actualSyleLabelHover={LabelStyleBreeds}
          />
        ) : (
          <NotFound />
        )}
      </div>
    </div>
  );
};

export { Search };
